import React from 'react';
import styled from 'App/styled';
import ToolTip from '@nykaa/delivery-desktop/components/ToolTip';
import { PrimaryCategories } from 'store/product/types';
import ReturnIcon from './returnSvg';
import returnPolicyText from '../utils';

const RETURN_POLICY = 'Return Policy';
interface ReturnStyleProps {
  contentClass: string;
}
interface ReturnProps {
  primaryCategories?: PrimaryCategories;
  returnAvailable: boolean;
  messageOnReturn: string;
}
const ReturnText = styled.div`
  display: flex;
  margin-right: ${({ theme }) => theme.spacing.spacing120};
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-right: ${({ theme }) => theme.spacing.spacing60};
  }

  &:nth-last-of-type(2) {
    margin-right: ${({ theme }) => theme.spacing.spacing120};

    @media (min-width: 768px) and (max-width: 1024px) {
      margin-right: ${({ theme }) => theme.spacing.spacing60};
    }
  }
  &:hover {
    .${({ contentClass }: ReturnStyleProps) => contentClass} {
      visibility: visible;
    }
  }

  svg {
    margin-right: ${({ theme }) => theme.spacing.spacing20};
    width: 27px;
    height: 27px;
  }
`;

const Text = styled.span`
  display: inline-block;
  vertical-align: middle;
  padding-top: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.subTitleMedium};
`;
const LinkText = styled.a`
  display: inherit;
  vertical-align: middle;
  text-decoration: none;
  color: inherit;
  svg {
    margin-right: ${({ theme }) => theme.spacing.spacing20};
    width: 27px;
    height: 27px;
  }
`;

const Return = ({
  primaryCategories,
  returnAvailable,
  messageOnReturn,
}: ReturnProps) => (
  <ReturnText contentClass="returnText">
    {primaryCategories?.l1?.name === 'Appliances' ? (
      <LinkText
        href="https://www.nykaa.com/cancellation-policy/lp"
        className="regular-link"
        title={RETURN_POLICY}
      >
        <ReturnIcon />
        <Text>Return Policy</Text>
      </LinkText>
    ) : (
      <>
        <ReturnIcon />
        <Text>{returnPolicyText(returnAvailable)}</Text>
        <ToolTip
          message={messageOnReturn}
          contentClass="returnText"
        />
      </>
    )}
  </ReturnText>
);

export default Return;
